import React from 'react'
import { StyledNavbarLogoSection, StyledNavbarNotificationAndProfileSection, StyledNavbarSearchButton, StyledNavbarSearchSection, StyledNavbarSection, StyledNotificationButton, StyledProfileButton } from './style.navbar'
import { Icon } from "@iconify/react";



const Navbar = () => {
    return (
        <>
            <StyledNavbarSection>
                <StyledNavbarLogoSection>
                    <img src='Assets/images/logo.png' alt="" style={{ width: 80, height: 'auto' }}></img>
                </StyledNavbarLogoSection>
                <StyledNavbarSearchSection>
                    <StyledNavbarSearchButton><Icon icon="hugeicons:search-01" width="18" height="18" /></StyledNavbarSearchButton>
                </StyledNavbarSearchSection>
                <StyledNavbarNotificationAndProfileSection>
                    <StyledNotificationButton><span><Icon icon="emojione-v1:ringing-bell" width="30" height="30" /></span></StyledNotificationButton>
                    <StyledProfileButton><span><Icon icon="fluent-emoji:person-light" width="32" height="32" /></span></StyledProfileButton>
                </StyledNavbarNotificationAndProfileSection>
            </StyledNavbarSection>
        </>
    )
}

export default Navbar
